import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { PaginatorLiteralsFacadeService } from 'src/app/shared/services/literals/paginator.literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { UserSearchFacadeService } from './user-search.facade.service';

@Injectable({ providedIn: 'root' })
export class UserSearchService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private paginatorService: PaginatorFacadeService,
    private paginatorLiterals: PaginatorLiteralsFacadeService,
    private userSearch: UserSearchFacadeService,
  ) {}

  users(): Observable<QcResponseGrid> {
    const url =
      this.environmentFacadeService.getEnvironment() +
      `/rest/v1/usermanagement/findByFilter?start=${
        this.paginatorService.pageIndex * this.paginatorService.itemsNumber
      }&pageSize=${this.paginatorService.itemsNumber}&sortField=${
        this.paginatorService.selectedSortField === this.paginatorLiterals.userUserName
          ? 'USER_NAME'
          : this.paginatorService.selectedSortField === this.paginatorLiterals.userDisplayedName
            ? 'DISPLAY_NAME'
            : this.paginatorService.selectedSortField === this.paginatorLiterals.userEmail
              ? 'EMAIL'
              : null
      }&sortOrder=${this.paginatorService.selectedOrder === this.paginatorLiterals.orderAsc ? 'ASC' : 'DESC'}`;

    return this.http.post<QcResponseGrid>(
      url,
      {
        businessGroupId: this.userSearch.businessGroupId,
        deleteFlag: this.userSearch.deactivated,
        displayedName: this.userSearch.displayedName ? this.userSearch.displayedName : null,
        email: this.userSearch.email ? this.userSearch.email : null,
        quickSight: this.userSearch.quicksight,
        securityGroupId: this.userSearch.securityGroupId,
        userName: this.userSearch.userName ? this.userSearch.userName : null,
      },
      {
        withCredentials: true,
        context: new HttpContext().set(IS_SEARCH, true),
      },
    );
  }
}
